import { Component, EventEmitter, OnInit, Output, ViewChild, Input } from '@angular/core';
import { Stripe, StripeCard, StripeScriptTag } from 'stripe-angular';
import { StripeError } from "@stripe/stripe-js";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {environment} from '../../../../environments/environment';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

@Component({
  selector: 'app-payment-popup',
  templateUrl: './payment-popup.component.html',
  styleUrls: ['./payment-popup.component.scss']
})
export class PaymentPopupComponent implements OnInit {
  form: UntypedFormGroup;
  formSubmitted = false;
  @Input() hidePaymentButton = false;
  userName = '';
  @Input() amount: any = '';
  @Input() domainId: any = '';
  subscriptionName: any = '';
  @Input() userSubscription = false;
  newCard = false;
  @Output() confirmAction: EventEmitter<any> = new EventEmitter();
  @Output() paymentResponse: EventEmitter<any> = new EventEmitter();
  @Output() emitHidePaymentButton: EventEmitter<any> = new EventEmitter();
  user: any;



  constructor(fb: UntypedFormBuilder, private stripeScriptTag: StripeScriptTag, private authenticationService: AuthenticationService) {
    // environment.stripe.public
    this.form = fb.group({
      cardholderName : ['', [Validators.required]],
      token : ['', [Validators.required]],
      cardRegion : [''],
      cardNumber : [''],
    });
  }

  ngOnInit(): void {
    this.user = this.authenticationService.userValue;
    this.f.cardholderName.setValue(this.userName);
    console.log(this.userName);
    if (!this.stripeScriptTag.StripeInstance) {
      console.log(this.domainId, parseInt(this.domainId));
      if (parseInt(this.domainId) == 71 && this.user.isProductSubscriber == '1') {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_atg);
      } else if (parseInt(this.domainId) == 515 && this.user.isProductSubscriber == '1') {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_atgtraining);
      } else if (parseInt(this.domainId) == 386 && this.user.isProductSubscriber == '1') {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_autoshopanswers);
      } else if (parseInt(this.domainId) == 64 && this.user.isProductSubscriber == '1') {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_autodiagclinic);
      } else if (this.domainId == 395) {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_lmv);
      } else if (this.domainId == 485) {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_codysautodiagnostics);
      } else if (this.domainId == 367) {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_evtech);
      } else {
        if (parseInt(this.domainId) == 386) {
          this.stripeScriptTag.setPublishableKey(environment.stripe.public_autoshopanswers);
        } else {
          this.stripeScriptTag.setPublishableKey(environment.stripe.public);
        }
      }
    }
  }

  extraData = { metadata: null };
  cardCaptureReady = 0;
  stripeOptions = {
    disableLink: true,
    hidePostalCode: true,
    style: {
      base: {
        color: "#495057",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      },
      complete: {
        color: "#495057",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      },
      empty: {
        color: "#495057",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      },
      invalid: {
        color: "#eb1c26",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      }
    }
  };
  invalidError: any;
  cardDetailsFilledOut: any = false;
  stripeError: string = "";
  showCardError: boolean = false;
  cardInitialized: boolean = false;

  @ViewChild("stripeCard") stripeCard: StripeCard;

  get f() { return this.form.controls; }

  onStripeInvalid(error: any) {
    this.stripeError = error?.message ? error?.message : "";
  }

  onStripeError(error: any) {
    console.error('Stripe error', error);
  }

  onStripeChanged(error: any) {
    if (!this.cardInitialized) this.cardInitialized = true;
    else this.showCardError = true;
  }

  setStripePaymentMethod(token: any) {
    console.log('Stripe Payment Method', token);
  }

  setStripeToken(token: any) {
    // this.hidePaymentButton = true;
    this.emitHidePaymentButton.emit(true);
    this.f.token.setValue(token.id);
    this.f.cardRegion.setValue(token.card.country);
    this.f.cardNumber.setValue(token.card.last4);
    this.paymentResponse.emit(this.form.value);
  }

  setStripeSource(source: any) {
    console.log('Stripe Source', source);
  }

  paymentSubmit() {
    this.formSubmitted = true;
    this.stripeCard.createToken();
  }

  closePopup(flag) {
    this.confirmAction.emit(flag)
  }

}
